import { BrandLogoEntity } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoCreateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoCreateResponseDTO.validationSchema(),
    BrandLogoEntity
  );

  constructor(readonly data: RoomBrandLogoCreateResponse) {
    JsonSchemaValidator.assert(RoomBrandLogoCreateResponseDTO.validation, data);
  }

  toJSON() {
    return this.data;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  private static validationSchema() {
    return {
      type: "object",
      required: ["brandLogo"],
      properties: {
        brandLogo: {
          instanceof: BrandLogoEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandLogoCreateResponse {
  brandLogo: BrandLogoEntity;
}
